import React from 'react';
import { useAds } from 'hooks/use-ads';

const AdConfig: React.FC = () => {
    const config = useAds();

    if (!config || !config.enabled) {
        return null;
    }

    return (
        <>
            <script dangerouslySetInnerHTML={{ __html: `var onetAds = (${JSON.stringify(config)})` }}/>
            <script src="//lib.onet.pl/s.csr/init/init.js" async={true}/>
        </>
    );
};

export default AdConfig;
